import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { ChipConnector } from '../ChipConnector/ChipConnector';
import { FilterChip } from '../FilterChip/FilterChip';
import { agreementDescriptors, paymentDescriptors } from './SettingsChips.utils';
export const GetSettingsChipsTID = (parentTestId)=>getTestIds(parentTestId);
export const SettingsChips = (param)=>{
    let { testId, paymentSettings, agreementSettings, onPaymentSettingsChange, onAgreementSettingsChange } = param;
    const { SettingsChipsTestIds } = useMemo(()=>GetSettingsChipsTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const descriptors = [
        ...paymentSettings != null ? paymentDescriptors(paymentSettings, onPaymentSettingsChange, t) : [],
        ...agreementSettings != null ? agreementDescriptors(agreementSettings, onAgreementSettingsChange, t) : []
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: descriptors.map((descriptor, index)=>/*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                        testId: SettingsChipsTestIds.AndConnector(index - 1),
                        tone: "and"
                    }),
                    /*#__PURE__*/ _jsx(FilterChip, {
                        testId: SettingsChipsTestIds.Chip(descriptor.field),
                        fieldLabel: descriptor.fieldLabel,
                        valueLabel: descriptor.valueLabel,
                        onRemove: descriptor.onRemove,
                        removeBiName: "drafts_ai_search_chip_remove_settings_".concat(descriptor.field),
                        tone: "settings"
                    })
                ]
            }, descriptor.field))
    });
};
